import { useState, useEffect } from 'react';

import ContactApi from '../../api/platform/contactApi';
import styles from '../../css/support/support.module.css';
import { ContactSubmissionModel } from '../../models/platform/contactSubmissionModel';
import { UserModel } from '../../models/platform/userModel';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';

interface SupportModalProps {
    open: boolean;
    onClose: () => void;
    user?: UserModel | null;
}

export const SupportModal: React.FC<SupportModalProps> = ({ open, onClose, user }) => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); // ✅ added

    useEffect(() => {
        if (open) {
            setSubject('');
            setMessage('');
            setIsSubmitted(false); // ✅ reset on open
        }
    }, [open]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const payload: ContactSubmissionModel = {
                name: (user?.first_name + ' ' + user?.last_name) || 'anonymous',
                email: user?.email || 'noemail@example.com',
                email_message: message,
                message_type: 'support',
            };

            const response: ResponseSuccessModel = await ContactApi.sendSupportRequest(payload);

            setIsSubmitted(true); // ✅ show thank-you instead of closing
        } catch (err) {
            console.error('Error sending support request:', err);
            alert('Something went wrong sending your support request.');
        }
    };

    if (!open) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                {!isSubmitted && <h2>Contact Support</h2>}
                {!isSubmitted ? (
                    <form onSubmit={handleSubmit}>
                        <label>
                            Subject
                            <input
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                required
                            />
                        </label>

                        <label style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            Message
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                                style={{ flex: 1 }}
                            />
                        </label>

                        <div className={styles.buttonRow}>
                            <button type="submit">Send</button>
                            <button type="button" onClick={onClose}>Cancel</button>
                        </div>
                    </form>
                ) : (
                    <div className={styles.confirmationMessage}>
                        <h3>✅ Message sent!</h3>
                        <p>Thanks for reaching out. We’ll get back to you soon.</p>
                        <button onClick={onClose}>Close</button>
                    </div>
                )}
            </div>
        </div>
    );
};
